<template>
  <div class="card border-0 card-with-shadow mb-primary">
    <div class="card-header d-flex align-items-center justify-content-between p-primary bg-transparent">
      <h5 class="card-title text-muted m-0">{{ $t('argon_info') }}</h5>
    </div>
    <div class="card-body">
      <template v-for="(argon, index) in argonInfo.argons">
        <div class="media d-flex align-items-center mb-3">
          <app-avatar
            :img="argon.profile_picture
                                ? urlGenerator(argon.profile_picture.path)
                                : argon.profile_picture"
            :title="argon.name"
            avatar-class="avatars-w-40"
            class="mr-2"/>

          <div class="media-body">
            {{ argon.name }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {urlGenerator} from "@app/Helpers/helpers";
export default {
  name: "DealArgonInfo",
  props: ['argonInfo'],
  data() {
    return {
      urlGenerator,
    }
  },
}
</script>

